
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const EditMealHeader = () => {
  return (
    <div className="text-center mb-6">
      <h1 className="text-2xl font-semibold">Edit Meal</h1>
    </div>
  );
};
